export default __webpack_public_path__ + "static/media/multiStepsForm.dbc12f1d.png";